module.exports = __webpack_public_path__ + "img/LogotipoLatinoSegurosBlanco.d2b30aff.png";